import HttpRequest from '@/config/axios.config'

export const getSupplierRef = async (payload) => {
  return await HttpRequest.get(`/suppliers`, { params: payload })
}

export const getCountryRef = async () => {
  return await HttpRequest.get(`/countries`)
}

export async function savePropertyValuesRef(id, payload: any) {
  return await HttpRequest.post(
    `/properties/${id}/property-values`,
    payload
  ).catch((error) => error.response.data.message)
}

export async function getPropertiesRef() {
  return await HttpRequest.get('/properties')
}

export async function getPropertyDetailRef(id: string) {
  return await HttpRequest.get(`/properties/${id}`)
}

export async function getPropertyValueRef(data: any) {
  return await HttpRequest.get('/properties/property_values', {
    params: data,
  })
}

export async function getPropertyValueInspectionTypeRef() {
  try {
    const {
      data: { data = [] },
    } = await HttpRequest.get('/properties/property_values/inspectionType')

    return data
  } catch (error) {
    return { data: [], statusCode: 200, pagination: {} }
  }
}

export async function getPropertyValueInspectionBrandRef() {
  try {
    const {
      data: { data = [] },
    } = await HttpRequest.get('/properties/property_values/brand')

    return data
  } catch (error) {
    return { data: [], statusCode: 200, pagination: {} }
  }
}

export async function updatePropertyValueRef(id: string, data: any) {
  return await HttpRequest.put(`properties/property_values/${id}`, data).catch(
    (error) => error.response.data.message
  )
}

export async function deletePropertyValueRef(id: string) {
  return await HttpRequest.put(`properties/property_values/${id}/delete`)
}

export async function createPropertyRef(data) {
  return await HttpRequest.post('/properties', data)
}

export async function updatePropertyRef(id: string, data) {
  return await HttpRequest.put(`/properties/${id}`, data)
}

export async function saveSupplierRef(payload) {
  return await HttpRequest.post('/suppliers', payload).catch(
    (error) => error.response.data.message
  )
}

export async function updateSupplierRef(id, payload) {
  return await HttpRequest.put(`/suppliers/${id}`, payload).catch(
    (error) => error.response.data.message
  )
}

export async function deleteSupplierRef(payload: any) {
  return await HttpRequest.put(`/suppliers/${payload.id}`, payload)
}

export async function defectListRef(data: any) {
  return await HttpRequest.get(`/defect-groups`, { params: data })
}

export async function defectItemRef(id) {
  return await HttpRequest.get(`/defect-groups/${id}/defect-lists`, {
    params: {
      status: 'active',
    },
  })
}

export async function saveDefectListRef(data: any) {
  return await HttpRequest.post(`/defect-groups`, data)
}

export async function saveDefectItemRef(data: any) {
  return await HttpRequest.post(`/defect-lists`, data)
}

export async function updateDefectItemRef(id, data: any) {
  return await HttpRequest.put(`/defect-lists/${id}`, data)
}

export async function updateDefectListRef(id: string, data: any) {
  return await HttpRequest.put(`/defect-groups/${id}`, data)
}

export async function deleteDefectGroup(id: string) {
  return await HttpRequest.delete(`/defect-groups/${id}`).catch(
    (error) => error.response
  )
}

export async function deletePropertyRef(id: string) {
  return await HttpRequest.delete(`/properties/${id}`)
}

export async function getAQLPropertyValues(aqlType: 'measurement' | 'default') {
  return await HttpRequest.get('/properties/aql_property_values', {
    params: {
      aql_type: aqlType,
      all: true,
    },
  })
}
